import { createSlice } from "@reduxjs/toolkit";

export const tabAdvancedSlice = createSlice({
  name: "tabAdvancedSlice",
  initialState: {
    certificates: [],
    ewcJobs: [],
    programs: [],
    offenseCategoryTypes: [],
  },
  reducers: {
    insertCertificates: (state, action) => {
      state.certificates = action.payload;
    },
    insertEWCJobs: (state, action) => {
      state.ewcJobs = action.payload;
    },
    insertPrograms: (state, action) => {
      state.programs = action.payload;
    },
    insertOffenseCategoryTypes: (state, action) => {
      state.offenseCategoryTypes = action.payload;
    },
  },
});

export const {
  insertCertificates,
  insertEWCJobs,
  insertPrograms,
  insertOffenseCategoryTypes,
} = tabAdvancedSlice.actions;
export default tabAdvancedSlice.reducer;
